// noinspection JSAnnotator

import classNames from 'classnames';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  InitiativeLink,
  InitiativePreviewLink,
  SurveyLink,
} from '../links/index.jsx';
import SentimentDot from '../SentimentDot.jsx';
import { getOrgSlug } from '../../lib/utils.js';
import styles from './InitiativeParticipationLabel.module.css';

const InitiativeParticipationLabel = (props) => {
  const {
    isPreview,
    initiative,
    initiativeParticipation,
    showCompletionDot,
    showSentimentDot,
    isActive,
    label,
    showSurvey,
    status,
    sentiment,
  } = props;

  const [searchParams] = useSearchParams();
  const initiativeParticipationId = initiativeParticipation?.id;

  const Link = showSurvey
    ? SurveyLink
    : isPreview
      ? InitiativePreviewLink
      : InitiativeLink;

  const linkProps = {
    initiative,
    initiativeParticipationId,
    stakeholderParticipationId: searchParams.get('stakeholder'),
    scroll: false,
  };

  if (showSurvey) {
    linkProps.status = status;
    linkProps.sentiment = sentiment;
  }

  const labelText = initiativeParticipation
    ? `${initiativeParticipation.label} (${initiativeParticipation.leavesCount})`
    : label;

  return (
    <Link {...linkProps} slug={getOrgSlug()}>
      <a className={classNames({ 'text-active': isActive })}>
        <strong
          className={`${styles.strong} ${initiativeParticipation?.archived ? 'text-muted' : ''}`}
        >
          {labelText}
        </strong>
        {showCompletionDot &&
          initiativeParticipation &&
          initiativeParticipation.leavesCompletedCount <
            initiativeParticipation.leavesCount && (
            <SentimentDot outline sentiment="strongly_disagree" small />
          )}
        {showSentimentDot && initiativeParticipation && (
          <SentimentDot
            sentiment={initiativeParticipation.surveyLeavesAverageSentiment}
            small
          />
        )}
      </a>
    </Link>
  );
};

InitiativeParticipationLabel.defaultProps = {
  isActive: false,
  showCompletionDot: false,
  showSentimentDot: false,
  showOutlineBox: false,
};

export default InitiativeParticipationLabel;
